module.exports = __webpack_public_path__ + "static/media/check.06dccf5c.svg";